<template>
  <v-row>
    <v-col cols="12">
      <TaskHeader />
    </v-col>
    <v-col cols="12">
      <Tasks v-if="id == 'list'" />
    </v-col>
  </v-row>
</template>

<script>
import TaskHeader from '@/components/tasks/Header';
import Tasks from '@/components/tasks/List';
export default {
  name: 'TaskDetail',
  components: {
    TaskHeader,
    Tasks
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  async mounted() {
    if (!this.id) {
      this.$router.push('/tasks/list');
    } else {
      await Promise.all([
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getDesignGroups'),
        this.$store.dispatch('lookup/getDesigners'),
        this.$store.dispatch('lookup/getProducts'),
        this.$store.dispatch('lookup/getIndustries'),
        this.$store.dispatch('lookup/getTopics')
      ]);
    }
  }
};
</script>
